<template>
  <nav>
    <!-- Original -->
    <v-app-bar dark app class="header pb-5" clipped-left>
    <!-- UC
    <v-app-bar app class="header pb-5" clipped-left> -->
      <!--  HAMBURGER ICON (MENU ICON)  -->
      <!-- <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon> -->

      <!--  HEADER TITLE  -->
      <v-toolbar-title>
        <span class="text-md-h4 font-weight-bold"></span>
        <!-- Original -->
        <img
          src="../assets/efakturelogowhite.png"
          height="70px"
          class="mt-2 logo"
          @click="redirectToHomePage()"
        />
        <!-- UC
        <img
          src="../assets/unicredit-logo.png"
          height="35px"
          class="mt-2 logo"
          @click="redirectToHomePage()"
        /> -->
      </v-toolbar-title><span>{{ this.testVersion }}</span>
      <v-spacer></v-spacer>

      <!--  USER'S ORGANIZATION -->
      <v-select
          ref="selectOrganization"
          v-if="isUserLogged"
          :value="selectedOrganization"
          :items="loggedUser.organization"
          item-text="name"
          item-value="organizationId"
          v-bind:label="getOrganizationLabel"
          class="selectOrganization"
          @input="changeOrganization"
          v-bind:no-data-text="$t('noData')"
          return-object
          dense
        >
        </v-select>
      <v-spacer></v-spacer>

      <!--  LOGIN/REGISTER BUTTON WHEN USER IS NOT LOGGED IN  -->
      <v-toolbar-items v-if="!isUserLogged && showLoginButton" class="py-2">
        <!--  LOGIN BUTTON  -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }"><!--#04835d--><!-- UC #b30404 -->
            <v-btn v-bind="attrs" v-on="on" dark color="#04835d" @click="login()"
              ><v-icon>login</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('login') }}</span>
        </v-tooltip>

        <!--  REGISTER BUTTON  -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }"><!--#024d37--><!-- UC #b30404-->
            <v-btn v-bind="attrs" v-on="on" dark color="#024d37"
              ><v-icon>person_add</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('signup') }}</span>
        </v-tooltip>
      </v-toolbar-items>

      <!--  HEADER USER ICON WHEN USER IS LOGGED IN -->
      <v-toolbar-items v-if="isUserLogged">
        <div
          :class="{
            'mt-1': $vuetify.breakpoint.smAndDown,
            'mt-2': $vuetify.breakpoint.mdAndUp,
          }"
        >
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <!--  HEADER USER ICON  -->
              <div class="" v-bind="attrs" v-on="on">
                <span v-if="authType == 'DB'" class="mr-3">{{ loggedUser.name + ' ' + loggedUser.lastname }}</span>
                <span v-else class="mr-3">{{ loggedUser.name }}</span>
                <v-btn
                  depressed
                  elevation="2"
                  icon
                  outlined
                  class="text-md-h6 pa-5"
                >
                  <v-icon large>person</v-icon>
                </v-btn>
              </div>
            </template>

            <v-card>
              <v-list>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon large>face</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-if="authType == 'DB'">
                      {{ loggedUser.name + " " + loggedUser.lastname }}
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      {{ loggedUser.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ loggedUser.username }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>email</v-icon>
                  </v-list-item-action>
                  <v-list-item-title>{{ loggedUser.email }}</v-list-item-title>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-switch
                      v-model="enableEmailNotifications"
                      color="#2b5d66"
                    ></v-switch>
                  </v-list-item-action>
                  <v-list-item-title
                    >{{ $t('emailNotification') }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn v-if="authType == 'DB'" text @click="showInfo()"> {{ $t('edit') }} </v-btn>
                <v-btn v-if="authType == 'DB'" color="#2b5d66" text @click="logout()"> {{ $t('signout') }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </v-toolbar-items>
    </v-app-bar>

    <!--  NAVIGATION DRAWER  -->
    <v-navigation-drawer
      app
      clipped
      permanent
      v-model="drawer"
      class="nav-drawer"
      v-if="isUserLogged"
      :key="navigationKey"
      ref="drawer"
      :width="navigation.width"
    >
      <v-list class="mt-2 text-center" tile rounded>
        <!--  Archivo EFaktura logo  -->
        <!--<v-list-item
          v-if="
            $vuetify.breakpoint.xs ||
            $vuetify.breakpoint.sm ||
            $vuetify.breakpoint.md
          "
          class="mb-10"
        >
          <v-list-item-action>
            <v-avatar>
              <v-img src="../assets/logo.png"></v-img>
            </v-avatar>
          </v-list-item-action>
          <v-list-item-title>
            <v-img src="../assets/e-faktura-logo.png"></v-img>
          </v-list-item-title>
        </v-list-item>-->

        <v-list-item
          v-for="link in links"
          v-bind:key="link.id"
          :to="link.route"
          class="list-item mt-3"
          v-show="userPermission(link.permission)"
        >
          <v-list-item-action>
            <v-icon>
              {{ link.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-title class="text-left" style="font-size:14px">
            {{ $t(link.name) }}
          </v-list-item-title>
          <v-spacer></v-spacer>
        </v-list-item>
        <v-list-item
        :href= this.$config.UCDynamicFormsLink
        class="list-item mt-3"
        v-if="userPermission('UCDynamicForms')">
        <v-list-item-action>
            <v-icon>
              east
            </v-icon>
          </v-list-item-action>
          <v-list-item-title class="text-left"  style="font-size:14px">
            Lista  zaduženja
            </v-list-item-title>
          <v-spacer></v-spacer>
        </v-list-item>
        <v-list-group
        append-icon=null
        prepend-icon="mdi-cog-outline"
        no-action
        v-show="userPermission('Administration')"
        >
          <template v-slot:activator>
            <v-list-item-title class="text-left" style="font-size:14px"
            >
              {{ $t('settings') }}
            </v-list-item-title>
          </template>
          <v-list-item
            v-for="setting in settings"
            v-bind:key="setting.id"
            :to="setting.route"
            class="list-item mt-3"
            v-show="settingsPermission(setting.permission)"
          >
            <v-list-item-action>
              <v-icon>
                {{ setting.icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title class="text-left"  style="font-size:14px">
              {{ $t(setting.name) }}
            </v-list-item-title>
          <v-spacer></v-spacer>
        </v-list-item>
        </v-list-group>
      </v-list>
      
      <!--  PIS Software products in navigation drawer  -->
      <!--<template v-slot:append>
        <v-row class="text-center mb-3">
          <v-col>
            <v-btn outlined text>
              <v-icon left color="grey darken-3">business</v-icon>
              <span class="location-text-in-nav-bar text-uppercase"> PIS </span>
            </v-btn>
          </v-col>
        </v-row>
      </template>-->
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  name: "Header",
    data() {
    return {
      enableEmailNotifications: true,
      menu: false,
      drawer: true,
      select: {},
      navigationKey: 0,
      navigation: {
        shown: false,
        width: 250,
        borderSize: 2
      },
      userNavLinks: [
        {
          name: "Profil",
          icon: "face",
        },
        {
          name: "Odjavi se",
          icon: "exit_to_app",
        },
      ],
      links: [
         {
          id: 0,
          name: "newInvoice",
          route: "/archivo/newinvoice",
          icon: "edit_note",
          permission: "CreateNewInvoice"
        },
        {
          id: 1,
          name: "output",
          route: "/archivo/output",
          icon: "west",
          permission: "SalesInvoice"
        },
        {
          id: 2,
          name: "input",
          route: "/archivo/input",
          icon: "east",
          permission: "PurchaseInvoice"
        },
        {
          id: 3,
          name: "fees",
          route: "/archivo/feeOutput", 
          icon: "west",
          permission: "Fees"
        },
        {
          id: 4,
          name: "individualVatRecord",
          route: "/archivo/individualVatRecord", 
          icon: "description",
          permission: "IndividualVatRecord"
        },
        {
          id: 5,
          name: "groupVatRecord",
          route: "/archivo/GroupVatRecord", 
          icon: "insert_chart_outlined",
          permission: "GroupVatRecord"
        },
        {
          id: 6,
          name: "report",
          route: "/archivo/reports",
          icon: "stacked_bar_chart",
          permission: "Reports"
        }
      ],
      settings: [
        {
          id: 1,
          name: "organization",
          route: "/settings/organization",
          permission: "",
          icon: "business"
        },
        {
          id: 2,
          name: "users",
          route: "/settings/users",
          permission: "DB",
          icon: "group"
        },
        {
          id: 3,
          name: "invoiceNumber",
          route: "/settings/invoiceNumber",
          permission: "",
          icon: "text_snippet"
        }
      ]
    };
  },
  watch: {
    loggedUser: function() {
      if(this.isUserLogged) {
        if(this.loggedUser.organization.length === 1){
          this.changeOrganization(this.setFirstOrganization)
        }
      }
    }
  },
  mounted() {
    this.setBorderWidth();
    this.setEvents();
  },
  computed: {
    showLoginButton() {
      return this.$config.ShowLoginButton;
    },
    isUserLogged() {
      return this.$store.getters.isLoggedIn;
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    setFirstOrganization() {
      return this.$store.getters.loggedUser.organization[0];
    },
    selectedOrganization() {
      return this.$store.getters.organizationId;
    },
    organizationSet() {
      return this.$store.getters.organizationSet;
    },
    getOrganizationLabel() {
      if(this.organizationSet)
        return ""
        
      return this.$t('organization')
    },
    authType() {
      return this.$config.AuthConfigType;
    },
    testVersion() {
      return this.$config.TestVersion;
    }
  },
  methods: {
    redirectToHomePage() {
      if(this.$config.ShowWelcomePage && this.$router.currentRoute.path != '/welcomePage')
        this.$router.push({ name: "WelcomePage" });
      else if(!this.$config.ShowWelcomePage && this.$router.currentRoute.path != '/')  
        this.$router.push({ name: "Home" });
    },
    redirectTo(page) {
      this.$router.push({ name: page });
    },
    isLoggedIn() {     
      return this.$store.getters.isLoggedIn
    },
    userPermission(linkPermission) {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === linkPermission && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    settingsPermission(settingPermission) {
      if(settingPermission.length > 0)
        return this.$config.AuthConfigType == settingPermission;
      else  
        return true;
    },
    login() {
      this.$router.push({ name: "Login" })
    },

    logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: "Login" });
    },
    changeOrganization: function(value) {
      if(this.selectedOrganization != value.organizationId) {
        this.$store.dispatch('organizationChange', value.organizationId)
        .then(() => {
          this.navigationKey += 1; //reload navigation drawer
          if(this.$route.name != "Home")
            this.$router.push('/');
        })
      }
    },
    showInfo() {
      this.menu = !this.menu
      this.$router.push({ name: "UserInfo" })
    },
    setBorderWidth() {
      let i = this.$refs.drawer.$el.querySelector(
        ".v-navigation-drawer__border"
      );
      i.style.width = this.navigation.borderSize + "px";
      i.style.cursor = "ew-resize";
    },
    setEvents() {
      const minSize = this.navigation.borderSize;
      const el = this.$refs.drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      const direction = el.classList.contains("v-navigation-drawer--right") ?
        "right" :
        "left";

      function resize(e) {
        document.body.style.cursor = "ew-resize";
        let f =
          direction === "right" ?
          document.body.scrollWidth - e.clientX :
          e.clientX;
        el.style.width = f + "px";
      }

      drawerBorder.addEventListener(
        "mousedown",
        (e) => {
          if (e.offsetX < minSize) {
            el.style.transition = 'initial';
            document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        () => {
          el.style.transition = '';
          this.navigation.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    }
  },
};
</script>
    

<style scoped>
.header {
  /*- original */ background: #2b5d66 !important;
  color: white !important; 
  /*- UC  background: #F8F8FF !important;
  color: black !important; */
}

.location-text-in-nav-bar {
  color: rgb(42, 42, 42);
  font-weight: 500 !important;
}

.user-img {
  background: grey;
}

.nav-drawer {
  border-right: solid rgb(207, 207, 207) 0.5px;
}

.list-item {
  margin: 5px;
  border-radius: 4px;
}

.v-list-item--active {
  /*background: #047083;*/
  background: #2b5d66;
  color: white !important;
}
.selectOrganization {
    width: auto;
  }
</style>